module.exports = __webpack_public_path__ + "static/media/Poster_L1.080d9a63.svg";